import React from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'

const HelperCircle = styled.div`
  width: 14px;
  height: 14px;
  margin: 0 auto;
  margin-left: ${props => props.noLM ? '0' : '5px'};
  margin-bottom: ${props => props.noLM ? '3px' : '0'};
  background: #e4af27;
  background-image: url('/s/icons/help-pop.svg');
  border-radius: 50%;
`

const HelpText = ({ helpText, noLM, name }) => (
    <HelperCircle className="tooltip" noLM={noLM} data-test={`help-${name}`}>
      <div className="tooltip-text">
        { helpText }
      </div>
    </HelperCircle>
)

export default HelpText

HelpText.propTypes = {
  helpText: PropTypes.string,
  name: PropTypes.string,
  noLM: PropTypes.bool
}
